export default __webpack_public_path__ + "static/media/02_srnec_Kratochvil-min.499e0a8d.jpg";